import React, { useEffect } from "react";
import { Switch, Route, Redirect } from "../lib/common-components";
import TransferPage from "./Pages/TransferPage";
import WrapperPage from "./Pages/WrapperPage";
import { setupAbsoluteLabs } from "../lib/absolute-labs";
import { useCookieConsent } from "../lib/cookie-consent/useCookieConsent";

export const ROUTE_LINKS = {
  Transfer: "/transfer",
  Wrap: "/wrap",
  Explore: "/explore",
};

const FilesRoutes = () => {
  const { run, isConsentEnabled } = useCookieConsent();
  const absoluteLabsScriptSetupRef = React.useRef<ReturnType<typeof setupAbsoluteLabs>>()

  useEffect(() => {
    if (!isConsentEnabled) return;
  
    run(config => config, {
			onAccept: async service => {
        switch(service) {
          case 'absolute-labs':
            const absoluteLabsSiteId = process.env.REACT_APP_ABSOLUTE_LABS_SITE_ID

            if (!absoluteLabsSiteId?.trim()) {
              throw new Error('AbsoluteLabs script URL or site ID is missing')
            }

            absoluteLabsScriptSetupRef.current = setupAbsoluteLabs('https://storage.googleapis.com/al-web-sdk/al.min.js', absoluteLabsSiteId)
            break;
          default:
            console.warn('Unhandled service', service)
            break;
        }
			},
			onReject: async service => {
        switch(service) {
          case 'absolute-labs':
              ;(await absoluteLabsScriptSetupRef.current)?.forEach(destroy => destroy())

              absoluteLabsScriptSetupRef.current = undefined
              break;
          default:
            console.warn('Unhandled service', service)
            break;
        }
			}
		})
  }, [run, isConsentEnabled]);

  return (
    <Switch>
      <Route exact path={ROUTE_LINKS.Transfer} component={TransferPage} />
      <Route exact path={ROUTE_LINKS.Wrap} component={WrapperPage} />
      <Route exact path="/">
        <Redirect to={ROUTE_LINKS.Transfer} />
      </Route>
    </Switch>
  );
};

export default FilesRoutes;
